import {
  DataGrid,
  GridActionsCellItem,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarContainer,
  GridToolbarExport,
  ptBR,
} from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';

export const DataGridFiles = ({
  loadingData,
  data,
  columns,
  editMode,
  pageSize,
  rowsPerPageOptions,
  checkboxSelection,
  deleteRecord,
}) => {
  const [rows, setRows] = useState(data);
  const [rowModesModel, setRowModesModel] = useState({});

  useEffect(() => {
    setRows(data);
  }, [data]);

  const columnsWithActions = [
    {
      field: "actions",
      type: "actions",
      headerName: "",
      cellClassName: "actions",
      width: 50,
      editable: false,
      headerAlign: "center",
      align: "right",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            title={"Deletar"}
            icon={<DeleteRoundedIcon />}
            label="Deletar"
            onClick={handleDeleteClick(id)}
            color="inherit"
            sx={{ color: 'red', ':hover': { backgroundColor: 'rgb(250, 219, 219)' } }}
          />
        ];
      },
    },
  ];

  let columnFinal = columnsWithActions.concat(columns);

  const handleDeleteClick = (id) => () => {
    deleteRecord(id);
  };

  const processRowUpdate = (newRow) => { };

  const processRowUpdateError = (err) => { };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton sx={{ color: "#414141" }} size="20px" />
        <GridToolbarFilterButton sx={{ color: "#414141" }} size="20px" />
        <GridToolbarDensitySelector sx={{ color: "#414141" }} size="20px" />
        <GridToolbarExport sx={{ color: "#414141" }} size="20px" />
      </GridToolbarContainer>
    );
  }

  const configComponentsProps = {
    panel: {
      sx: {
        "& .MuiTypography-root": {
          color: "#2f3237",
          fontSize: 12,
        },

        "& .MuiSvgIcon-root": {
          color: "#2f3237",
          marginTop: "-1px",
        },
        "& .batteryTrunk": {
          marginTop: "-1px",
          color: "#2f3237",
        },
        "& .svg-inline--fa": {
          marginTop: "-1px",
          color: "#2f3237",
        },
        "& .MuiDataGrid-columnsPanelRow:first-of-type": {
          display: "none",
        },
        "& .MuiDataGrid-panelFooter button:first-of-type": {
          display: "none",
        },
      },
    },
    footer: {
      sx: {
        "& .MuiTablePagination-root": {
          minHeight: "30px",
          height: "30px",
        },
        "& .MuiTablePagination-toolbar": {
          marginTop: "5px",
          minHeight: "10px",
          height: "10px",
        },
        "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
        {
          fontSize: "12px",
          margin: 0,
          color: "black !important",
        },
        "& .MuiTablePagination-select": {
          margin: 0,
          fontSize: "12px",
        },
        "& .MuiTablePagination-actions": {
          margin: 0,
        },
        "& .css-rtrcn9-MuiTablePagination-root:last-child": {
          display: "contents",
        },
      },
    },
  };

  return (
    <Box
      sx={{
        height: '60vh',
        width: "100%",
        "& .dataGrid-true": {
          bgcolor: "#eeeeee",
        },
        "& .dataGrid-false": {
          bgcolor: "#ffffff",
        },
      }}
    >
      <DataGrid
        loading={loadingData}
        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
        components={{
          Toolbar: CustomToolbar,
        }}
        rows={rows}
        columns={columnFinal}
        rowModesModel={rowModesModel}
        editMode={editMode ?? "row"}
        processRowUpdate={processRowUpdate}
        onProcessRowUpdateError={processRowUpdateError}
        pageSize={pageSize ?? 10}
        rowsPerPageOptions={rowsPerPageOptions ?? [5]}
        checkboxSelection={checkboxSelection}
        experimentalFeatures={{ newEditingApi: true }}
        rowHeight={50}
        density={'compact'}
        getRowClassName={(params) =>
          `dataGrid-${params.row.isRemoved ? "true" : "false"}`
        }
        componentsProps={configComponentsProps}
      />
    </Box>
  );
};
